/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: Zhanglei
 * @Date: 2020-07-27 13:41:00
 * @LastEditTime: 2020-08-21 13:10:38
 * @LastEditors: Zhanglei
 * @Description:
 * @FilePath: /desktop/src/service/tableService.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import request from "@/utils/request";

/*
 *获取页面布局
 */
export function getTableHeaderApi(id) {
  return request({
    url: "/api/v1/mine/templates/" + id,
    method: "GET",
    data: {
      templateId: id
    }
  });
}

/*
 *获取页面数据
 */
export function getTableDataApi(idInfo) {
  return request({
    url: "/api/v1/accounts" + idInfo,
    method: "GET",
    data: idInfo
  });
}

/*
 *获取首页数据
 */
export function getHomeDataApi() {
  return request({
    url: "/api/v1/system/home",
    method: "GET"
  });
}

/*
 *更改编辑数据
 */
export function getChangeDataApi(data) {
  return request({
    url: "/api/v1/accounts/" + data.id,
    method: "PATCH",
    data: data.data
  });
}
/*
 * 删除数据
 */
export function deleteDataApi(id) {
  return request({
    url: "/api/v1/accounts/" + id,
    method: "DELETE"
  });
}
/*
 *创建数据
 */
export function postDataApi(data) {
  return request({
    url: "/api/v1/accounts",
    method: "POST",
    data: data
  });
}

/*
 *获取关联用户数据
 */
export function getUserApi(idInfo) {
  return request({
    url: "/api/v1/users",
    method: "GET"
  });
}

/*
 *查询关联用户数据
 */
export function getUserItemApi(idInfo) {
  return request({
    url: "/api/v1/users" + idInfo,
    method: "GET"
  });
}



// WEBPACK FOOTER //
// ./src/service/tableService.js